module.exports = __webpack_public_path__ + "img/game_main_pc_203_off.70d55669.png";